module.exports = __webpack_public_path__ + "img/bg.b2ab91d8.png";